export default __webpack_public_path__ + "static/fieldsImg-46810bbea2cc8136873ed1c1834a9594.png";